export default __webpack_public_path__ + "static/image2-3759916451c5fcd04f56d365a5d050fe.png";